/**
 * VORNEEL Editorial Motion Module
 * Lightweight, zero-dependency vanilla JS with IntersectionObserver.
 * Features:
 *  - 15% Viewport Intersection Trigger (fires once per heading)
 *  - Hardware accelerated opacity & transform reveals
 *  - Full prefers-reduced-motion fallback
 *  - Zero layout shift (CLS): No calculated element heights
 *  - Shopify Theme Editor (design mode) lifecycle support
 */

(function () {
  'use strict';

  // 1. Accessibility Check: prefers-reduced-motion
  var prefersReducedMotion = false;
  if (window.matchMedia) {
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    prefersReducedMotion = motionQuery.matches;
    motionQuery.addEventListener('change', function (e) {
      prefersReducedMotion = e.matches;
      if (prefersReducedMotion) {
        document.documentElement.classList.remove('has-deh-motion');
      }
    });
  }

  // If user prefers reduced motion or browser doesn't support IntersectionObserver,
  // do not activate reveal classes; headings remain naturally visible by default.
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    return;
  }

  // 2. Mark root document with motion capability
  document.documentElement.classList.add('has-deh-motion');

  var observer = null;

  function handleIntersect(entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }

  function getObserver() {
    if (!observer) {
      observer = new IntersectionObserver(handleIntersect, {
        threshold: 0.15,
        rootMargin: '0px 0px -30px 0px'
      });
    }
    return observer;
  }

  function observeHeadings(container) {
    var obs = getObserver();
    var root = container || document;
    var elements = root.querySelectorAll('[data-vn-heading]:not(.is-revealed)');

    elements.forEach(function (el) {
      obs.observe(el);
    });
  }

  // 5. Mobile Horizontal Scroll Indicators
  function initMobileSwipeIndicators(container) {
    var root = container || document;
    var swipeContainers = root.querySelectorAll('.vn-mobile-swipe-grid, .vn-reviews-grid');
    swipeContainers.forEach(function (slider) {
      if (slider.__swipeIndicatorInit) return;
      slider.__swipeIndicatorInit = true;

      var parent = slider.parentElement;
      var indicator = parent ? parent.querySelector('.vn-swipe-indicator-bar .vn-swipe-progress') : null;
      if (!indicator) return;

      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var maxScroll = slider.scrollWidth - slider.clientWidth;
            if (maxScroll > 0) {
              var ratio = Math.min(Math.max(slider.scrollLeft / maxScroll, 0), 1);
              indicator.style.transform = 'translateX(' + (ratio * 150) + '%)';
            }
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    });
  }

  // 3. Lifecycle Initialization
  function initAll(container) {
    observeHeadings(container);
    initMobileSwipeIndicators(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // 4. Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll();
  });

  // Public API helper for dynamically injected sections
  window.vnEditorial = window.vnEditorial || {};
  window.vnEditorial.refreshHeadings = initAll;
})();
